import React, { useContext } from "react"
import { Link } from "gatsby"

import ContentfulDataContext from "../context/contentful-data"

const Foods = props => {
  const { allContentfulFood } = useContext(ContentfulDataContext)

  const idealAminoAcids = {
    leucine: 55,
    lysine: 51,
    "phenylalanine+tyrosine": 47,
    valine: 32,
    threonine: 27,
    isoleucine: 25,
    "methionine+cystine": 25,
    histidine: 18,
    tryptophan: 7,
  }

  let foods = allContentfulFood.edges

  if (props.filter) {
    const filters = props.filter.split(" ")

    // Filter foods
    // All criteria should be met
    foods = foods.filter(({ node: food }) => {
      for (const filter of filters) {
        const [fProp, fVal] = filter.split(":")

        // @todo Fix partial slug:<name> matches – those are IDs and should
        // only be included on exact matches.
        if (
          !food[fProp] ||
          (food[fProp].indexOf && food[fProp].indexOf(fVal) < 0) ||
          (typeof food[fProp] === "object" &&
            food[fProp].slug &&
            food[fProp].slug.indexOf(fVal) < 0)
        ) {
          return false
        }
      }

      return true
    })
  }

  if (!foods.length) {
    return ""
  }

  return (
    <>
      {foods.map(({ node: food }) => {
        food.slug = food.slug ? food.slug : "/"
        food.nutritionObj = JSON.parse(food.nutrition.internal.content)
        food.price = food.price ? +food.price : 0

        const { price: fPrice, nutritionObj: fNutrition } = food
        const { aminoAcids } = fNutrition

        // The provided "food.price" is in EUR and for "food.weight" gram
        const pricePer100GramFood = fPrice ? (fPrice * 100) / food.weight : 0
        // Price per 100 gram protein
        const price = fPrice
          ? ((pricePer100GramFood * 100) / +fNutrition["protein"]).toFixed(1)
          : "?"

        // Potency
        const potency =
          (
            (+fNutrition["protein"] * 4) /
            (+fNutrition["protein"] * 4 +
              +fNutrition["carbohydrate"] * 4 +
              +fNutrition["fat"] * 9)
          ).toFixed(2) * 100

        // Profile
        const profiles = Object.keys(aminoAcids)
          .map(key => {
            const factor = (+fNutrition["protein"] / 1000) * 100
            let acidVal
            let acidValIdeal

            if (idealAminoAcids.hasOwnProperty(key)) {
              acidVal = +aminoAcids[key]
              acidValIdeal = idealAminoAcids[key]
            } else if (key === "phenylalanine") {
              acidVal = +aminoAcids["phenylalanine"] + +aminoAcids["tyrosine"]
              acidValIdeal = idealAminoAcids["phenylalanine+tyrosine"]
            } else if (key === "methionine") {
              acidVal = +aminoAcids["methionine"] + +aminoAcids["cystine"]
              acidValIdeal = idealAminoAcids["methionine+cystine"]
            } else {
              // Dummy value
              acidVal = 0
              acidValIdeal = 0
            }

            return Math.min((acidVal * factor) / acidValIdeal, 1)
          })
          // Remove dummy zero value
          .filter(profile => profile > 0)

        const profile =
          (
            profiles.reduce((acc, profile) => (acc += profile), 0) /
            profiles.length
          ).toFixed(2) * 100

        return (
          <React.Fragment key={food.contentful_id}>
            {!props.embedded ? (
              <>
                <h3 id={food.slug}>
                  {food.review ? (
                    <Link to={`/${food.review.slug}`}>{food.title}</Link>
                  ) : (
                    `${food.title}`
                  )}
                </h3>
                {food.excerpt ? <p>{food.excerpt.excerpt}</p> : ""}
              </>
            ) : (
              ""
            )}
            <div className="protein-powder-rating">
              <div
                className="circle price"
                title={
                  fPrice
                    ? "Price per 100 g of protein"
                    : "No reliable price information"
                }
              >
                <span>{fPrice ? `€${price}` : price}</span>
                <span className="label">Price</span>
              </div>
              <div
                className={`circle p${potency} ${potency > 50 ? "over50" : ""}`}
                title={`${potency}% of energy from protein`}
              >
                <span>{potency}%</span>
                <span className="label">Potency</span>
                <div className="left-half-clipper">
                  <div className="first50-bar"></div>
                  <div className="value-bar"></div>
                </div>
              </div>
              <div
                className={`circle p${profile}  ${
                  profile > 50 ? "over50" : ""
                }`}
                title="100% complete amino acid profile"
              >
                <span>{profile}%</span>
                <span className="label">Profile</span>
                <div className="left-half-clipper">
                  <div className="first50-bar"></div>
                  <div className="value-bar"></div>
                </div>
              </div>
            </div>
            {!props.embedded && food.body ? <p>{food.body.body}</p> : ""}
          </React.Fragment>
        )
      })}
    </>
  )
}

export default Foods
